import React from "react";
import "./StudentFeaturesSection.css";

import featureImg01 from '../assets/images/student/student-features-image-01.png';
import featureImg02 from '../assets/images/workstyles/startupsupport-image-02.jpeg';
import featureImg03 from '../assets/images/student/student-features-image-02.png';

const items = [
  {
    title: "自宅から通える",
    desc: `
      メタバース空間に教室があるため、<span class="highlight">どこに住んでいても</span>
      自宅から学校に参加することができます。
      <span class="big-text">移動時間や通学費用が不要</span>なので、
      自分の生活リズムを大切にしながら学習を進められます。
      <span class="highlight">地方在住や海外からでも同じ環境</span>で学べるのが大きな魅力です。
    `,
    icon: "home",
    img: featureImg01,
    
  },
  {
    title: "企業、自治体と連携",
    desc: `
      実際の課題を持つ企業や自治体と一緒にプロジェクトに取り組むことで、
      <span class="highlight">問題解決力</span>やチーム開発の経験を身につけられます。
      半年から1年をかけてじっくりと実務を体験し、
      <span class="big-text">社会で通用するスキル</span>を磨くことができます。
      例えば、連携企業のデバイスを活用して自治体の防災システムに
      <span class="highlight">機械学習モデルを導入</span>するといった実践も可能です。
    `,
    icon: "building",
    img: featureImg02,
  },
  {
    title: "リアルで意味のある成果物",
    desc: `
      学びの過程で取り組んだサービスやアプリ、AIモデルなどは、
      <span class="highlight">就職やフリーランス活動に直結するポートフォリオ</span>として活用できます。
      実際の課題解決を通して生まれるため、
      <span class="big-text">単なる演習課題とは違い説得力のある実績</span>となります。
      社会人としてのキャリアスタート時に
      <span class="highlight">強力な武器となる成果物</span>を手に入れられます。
    `,
    icon: "award",
    img: featureImg03,
  },
];

function Icon({ name }) {
  const c = "currentColor";
  switch (name) {
    case "home":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path fill={c} d="M12 3.1L2 12h2v9h6v-6h4v6h6v-9h2L12 3.1Z" />
        </svg>
      );
    case "building":
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path fill={c} d="M4 22V4a2 2 0 0 1 2-2h8l6 6v14H4Zm12-12h4l-4-4v4Z" />
          <path fill={c} d="M7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zm4-8h2v2h-2zm0 4h2v2h-2zm0 4h2v2h-2z" />
        </svg>
      );
    case "award":
    default:
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
          <path fill={c} d="M12 2a7 7 0 1 0 7 7a7 7 0 0 0-7-7Zm0 12a5 5 0 1 1 5-5a5 5 0 0 1-5 5Z" />
          <path fill={c} d="M8 22l4-2l4 2l-1-5l4-3.5l-5-.4L12 8l-2 5.1l-5 .4L9 17z" />
        </svg>
      );
  }
}

export default function StudentFeaturesSection({ cards = items }) {
  return (
    <div className="features" aria-labelledby="features-title">
      <div className="features__head">
        <h2 id="features-title" className="features__title">ここが魅力</h2>
        <p className="features__sub">革新的な学習環境で、実践的なスキルを身につけよう</p>
      </div>

      <div className="features__grid features__grid--3">
        {cards.map((f, i) => (
          <article key={i} className="featureCard">
            <div className="featureCard__imgWrap">
              <img src={f.img} alt="" className="featureCard__img" />
            </div>

            <div className="featureCard__body">
              <div className="featureCard__titleRow">
                <span className="featureCard__icon" aria-hidden="true">
                  <Icon name={f.icon} />
                </span>
                <h3 className="featureCard__title">{f.title}</h3>
              </div>
              <p className="featureCard__desc" dangerouslySetInnerHTML={{ __html: f.desc }} />
              {f.foot && <p className="featureCard__foot">{f.foot}</p>}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
